"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const zIndex_1 = __importDefault(require("../../../constants/zIndex"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const LoadingPageRenderer = ({ src, }) => {
    const { Render, dimentions } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const [frameStyle, lottieFrameStyle] = (0, react_1.useMemo)(() => {
        const computedStyle = {
            backgroundColor: 'rgba(52, 52, 52, 0.8)',
            position: 'absolute',
            justifyContent: 'center',
            alignItems: 'center',
            height: dimentions.window.height,
            maxHeight: dimentions.window.height,
            width: dimentions.window.width,
            maxWidth: dimentions.window.width,
            zIndex: zIndex_1.default.pageLoader,
        };
        const scale = 0.7;
        const dimention = dimentions.window.width * scale;
        const computedStyle2 = {
            width: dimention,
            maxWidth: dimention,
            height: dimention,
            maxHeight: dimention,
        };
        return [computedStyle, computedStyle2];
    }, [dimentions.window.width, dimentions.window.height]);
    return (react_1.default.createElement(Render.View, { style: frameStyle },
        react_1.default.createElement(Render.View, { style: lottieFrameStyle },
            react_1.default.createElement(Render.Lottie, { visible: true, loop: true, src: src || undefined, speed: 1 }))));
};
exports.default = LoadingPageRenderer;
